
(function uiServiceModuleDefinition() {

    angular.module('ui')
        .provider('ui', function () {

            var themingEnabled = false,
                uiData = {},
                uiCurrentThemeKey = 'ui.currentTheme',
                themesUrl = 'bundles/themes/themes.json';
            
            this.theming = function (enabled) {
                if (enabled === undefined) {
                    return themingEnabled;
                }
                themingEnabled = enabled;
            };

            this.themesUrl = function (url) {
                if (url === undefined) {
                    return themesUrl;
                }
                themesUrl = url;
            };

            uiData[uiCurrentThemeKey] = uiData[uiCurrentThemeKey] || { remember: true, value: null };

            this.rememberTheme = function (remember) {

                uiData[uiCurrentThemeKey].remember = remember;

                if (!remember && uiData[uiCurrentThemeKey].value) {
                    uiData[uiCurrentThemeKey].value = null;
                }

            };
            
            this.$get = ['onMobile', 'storage', '$rootScope', 'config', '$http', '$q',
                function uiService(mobile, storage, $rootScope, config, $http, $q) {

                    var themes = {},
                        uiService = {},
                        themesDeferred = $q.defer(),
                        themesPromise = themesDeferred.promise;
                    
                    // Guarda las claves de configuración en el local storage.
                    function saveConfiguration() {
                        var cachedData = {};

                        angular.forEach(uiData, function (value, key) {
                            if (value.remember) {
                                cachedData[key] = value;
                            }
                        });

                        storage.Local.store('ui', cachedData);
                    }

                    // Obtiene las claves de configuración del local storage.
                    function restoreConfiguration() {

                        var cachedData = storage.Local.getItem('ui');

                        // Por si deshabilitaron el theming o el remember y estaba recordado.
                        if (cachedData != null) {
                            
                            if (!themingEnabled
                                || (uiData[uiCurrentThemeKey]
                                    && !uiData[uiCurrentThemeKey].remember)) {
                                cachedData[uiCurrentThemeKey] = null;
                            } else if (cachedData[uiCurrentThemeKey]) {
                                // restauro el theme
                                uiService.setTheme(cachedData[uiCurrentThemeKey].value, true);
                            }

                            angular.extend(uiData, cachedData);
                        }
                    }

                    // Objeto que contentrá las configuraciones disponibles para los modulos de la UI.
                    uiService.configuration = {
                        define: function (key, remember, defaultValue) {
                            // ignoro la definición si el remember es true 
                            if (remember && uiData[key]) {
                                return;
                            }

                            uiData[key] = {
                                remember: remember,
                                value: defaultValue
                            };
                        },
                        /* Permite especificar una clave de configuración */
                        set: function (key, value) {

                            uiData[key] = uiData[key] || { remember: true, value: null };

                            uiData[key].value = value;

                            saveConfiguration();
                        },
                        get: function (key) {
                            if (!uiData[key])
                                return undefined;
                            return uiData[key].value;
                        }
                    };

                    uiService.configuration.define("ui.isMobile", false, mobile);

                    uiService.setTheme = function (themeName, internal) {
                        if (!themingEnabled)
                            return;

                        themesPromise.then(function () { 
                            if (themeName && themes[themeName]) {
                                $rootScope.themeStyle = themes[themeName].style;                                
                            }
                            else {
                                $rootScope.themeStyle = null;
                            }

                            if (!internal) {
                                uiService.configuration.set(uiCurrentThemeKey, themeName);
                            }
                        });
                    };

                    uiService.themes = function () {
                        return themes;
                    };

                    uiService.currentTheme = function () {
                        return uiService.configuration.get(uiCurrentThemeKey);
                    };
                    
                    restoreConfiguration();

                    if (themingEnabled) {
                        $http.get(config.resourceUrl(themesUrl))
                            .then(function (response) {
                                themes = response.data;
                                themesDeferred.resolve();
                            });
                    }

                    return uiService;
                }
            ];

        });

})();
